import { ChevronDown } from "lucide-react";

export type FaqItem = { q: string; a: string };

/**
 * FAQ-lijst op basis van native <details>/<summary>.
 *
 * Belangrijk voor SEO en AI-zoekmachines: het antwoord staat altijd in de
 * server-side HTML (ook als het item dichtgeklapt is), terwijl het
 * open/dicht-gedrag zonder JavaScript werkt.
 */
export function FaqList({ items }: { items: FaqItem[] }) {
  return (
    <div className="w-full divide-y divide-border">
      {items.map((item) => (
        <details key={item.q} className="group py-1">
          <summary className="flex w-full cursor-pointer list-none items-center justify-between gap-3 py-4 text-left text-sm font-semibold [&::-webkit-details-marker]:hidden">
            <span>{item.q}</span>
            <ChevronDown
              aria-hidden="true"
              className="size-4 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-180"
            />
          </summary>
          <div className="pb-4 text-sm leading-relaxed text-muted-foreground">{item.a}</div>
        </details>
      ))}
    </div>
  );
}

export function faqJsonLd(items: FaqItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
}
